export default {
    state: {
      isAuthenticated: JSON.parse(localStorage.getItem('isAuthenticated')) || false,
      loggedUser: JSON.parse(localStorage.getItem('loggedUser')) || null
    },
    mutations: {
      login(state, user) {
        state.isAuthenticated = true;
        state.loggedUser = user;
        localStorage.setItem('isAuthenticated', JSON.stringify(true));
        localStorage.setItem('loggedUser', JSON.stringify(user));
      },
      logout(state) {
        state.isAuthenticated = false;
        state.loggedUser = null;
        localStorage.removeItem('isAuthenticated'); 
        localStorage.removeItem('loggedUser');         
      },
    },
    actions: {
      login({ commit }, user) {
        commit('login', user);
      },
      logout({ commit }) {
        commit('logout');
      },
    },
    getters: {
      isAuthenticated: (state) => state.isAuthenticated,
      loggedUser: (state) => state.loggedUser,
      loggedUserName: (state) => (state.loggedUser ? state.loggedUser.name : '')
    },
  };
  